import { httpRequest } from '@/apis/request'
import {
  FetchPaibanTaskListPayload,
  SendToPaibanTaskPayload,
  UpdatePaibanTaskPayload,
} from '@/views/paibanTask/types'

enum Apis {
  sendToTaskList = 'layout_tasks',
  fetchPaibanTaskList = 'layout_tasks',
  updatePaibanTask = 'layout_tasks/',
}

export function sendToPaibanTaskList(payload: SendToPaibanTaskPayload) {
  return httpRequest.post(Apis.sendToTaskList, payload)
}

export function fetchPaibanTaskList(payload: FetchPaibanTaskListPayload) {
  const rePay = {} as FetchPaibanTaskListPayload
  if (payload.order_no) rePay.order_no = payload.order_no
  if (payload.status) rePay.status = payload.status
  rePay.page = payload.page ?? 1
  rePay.limit = payload.limit ?? 10
  return httpRequest.get(Apis.fetchPaibanTaskList, rePay)
}

export function updatePaibanTask(payload: UpdatePaibanTaskPayload) {
  return httpRequest.post(Apis.updatePaibanTask + payload.task.id, {
    action: payload.action,
  })
}
